module.exports = __webpack_public_path__ + "img/eye_off.a620b9b5.svg";